<template>
  <div class="justify-content-md-center">
    <div>
      <div v-if="lstAccount.length > 0">
        <b-row>
          <b-col>
            <span class="font-anuphan-regular-14 text-revamp-color-black">
              เลือกได้มากกว่า 1 บัญชี
            </span>
          </b-col>
        </b-row>

        <div>
          <b-card v-for="item in lstAccount" :key="item.accountNo" :class="'border-radius-sub-card ' +
            (isCardActive(item)
              ? 'card-active'
              : '' +
              ' ' +
              (checkEnable(item) ? 'card-disabled' : 'card-enabled'))
            " style="margin-top: 8pt" :body-class="'p-3 ' + (checkEnable(item) ? 'paleGrey cantClick' : 'canClick')
              " @click="onSelected(item)">
            <b-row>
              <b-col cols="">
                <b-row class="upload-type">
                  <div class="w-100" />
                  <b-col :class="checkEnable(item)
                    ? 'text-ktb-regular-disabled'
                    : 'font-anuphan-regular-14 text-revamp-color-black'
                    " align-self="center">
                    {{ covertAccountType(item.productGrp) }}
                    {{ patternAccount(item.accountNo) }}</b-col>
                  <div class="w-100" />
                  <b-col align-self="center">
                    <span :class="checkEnable(item)
                      ? 'text-ktb-regular-disabled'
                      : 'font-anuphan-bold-16 text-revamp-color-black'
                      " style="color: black !important">
                      {{ Number(item.balance).toLocaleString() }}
                    </span>
                    <span :class="checkEnable(item)
                      ? 'text-ktb-regular-disabled'
                      : 'font-anuphan-bold-16 text-revamp-color-black'
                      " style="color: black !important">
                      บาท</span>
                  </b-col>
                  <template v-if="checkEnable(item)">
                    <div class="w-100" />
                    <b-col class="text-ktb-regular-14-red" align-self="center">
                      {{ item.errorMsg }}</b-col>
                  </template>
                </b-row>
              </b-col>
              <b-col cols="auto" class="d-flex justify-content-center">
                <div class="custom-control custom-checkbox">
                  <input :value="item.accountNo" v-model="accountSelected" :disabled="checkEnable(item)" type="checkbox"
                    class="custom-control-input" :id="'customCheck' + item.accountNo" />
                  <label class="custom-control-label" for="customCheck1"></label>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    accountSelected: [],
    callback: Function,
    state: String,
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  async created() {
    if (this.userData.listAccount != undefined) {
      this.lstAccount = this.userData.listAccount;
    }
    this.handleLstAccount();
    this.scaleUpCheckbox();
  },
  data() {
    return {
      checkStateSuccess: false,
      imgNEXT: require("@/assets/images/BankLogo/KTB.png"),
      lstAccount: [],
      objAcc: null,
      urlapi: process.env.VUE_APP_APIURL,
      axiosInstance: null,
      periodStatementKtb: "",
      isUpload: false,
    };
  },
  methods: {
    scaleUpCheckbox() {
      // let c1 = checkboxs[0]
      document.styleSheets[0].addRule(
        "custom-control-label:before",
        "width: 24px"
      );
    },
    setIsLoading(value) {
      this.isUpload = value;
    },
    covertAccountType_tmp(accountType) {
      switch (accountType) {
        case "1":
          return "ออมทรัพย์";
        case "2":
          return "กระแสรายวัน";
        default:
          return "not found";
      }
    },
    covertAccountType(productGrp) {
      switch (productGrp) {
        case "SAV":
          return "ออมทรัพย์";
        default:
          return "กระแสรายวัน";
        // default:
        //   return "not found";
      }
    },
    checkEnable(item) {
      return item.errorMsg != undefined && item.errorMsg != "";
    },
    isCardActive(item) {
      return this.accountSelected.includes(item.accountNo);
    },
    onSelected(item) {
      if (this.checkEnable(item)) return;
      if (this.isCardActive(item)) {
        const index = this.accountSelected.indexOf(item.accountNo);
        if (index > -1) {
          this.accountSelected.splice(index, 1);
        }
      } else {
        this.accountSelected.push(item.accountNo);
      }
    },
    handleLstAccount() {
      if (this.lstAccount.length == 1) {
        if (this.callback) {
          this.callback("list-account-one", () => {
            return true;
          });
        }
        if (this.accountSelected.length === 0 && this.state === "wait") {
          this.onSelected(this.lstAccount[0]);
        }
      } else if (this.lstAccount.length === 0) {
        if (this.callback) {
          this.callback("list-account-empty", () => {
            return true;
          });
        }
      }
    },
    patternAccount(value) {
      return (
        "XXX" +
        "-" +
        "X" +
        "-XX" +
        value.substring(6, 9) +
        "-" +
        value.substring(9, 10)
      );
    },
  },
};
</script>
<style scoped>
.paleGrey {
  background: #f8f8f8 !important;
  border-radius: 12px;
  border: 0px solid #f8f8f8 !important;
}

.cantClick {
  cursor: not-allowed;
}

.badge-ktb-info {
  box-sizing: border-box;
  position: absolute;
  margin: -10px -10px;
  margin-top: 0rem;
  color: rgb(0, 166, 230) !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
}

.badge-primary {
  border: 2px solid rgb(0, 166, 230);
  box-sizing: border-box;
  position: absolute;
  margin: -10px 0px;
  margin-top: 2px;
  color: rgb(0, 166, 230) !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
}

.card-active {
  background: var(--color-card-actice);
  border: 1px solid var(--color-border-active);
}

.card-enabled {
  border: 0.5px solid var(--color-border-nonActive) !important;
}

.card-disabled {
  border: 0px !important;
  background: #f2f2f2 !important;
}

.custom-control-label::before {
  width: 24px !important;
  height: 24px !important;
}

.custom-control-label::after {
  width: 24px !important;
  height: 24px !important;
}

.btn-cancel-dstatement {
  color: rgb(219, 0, 0) !important;
  border-color: rgb(219, 0, 0) !important;
  background-color: white !important;
  background-image: unset !important;
}

.content-nowrap {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-left: unset;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
  background-image: url("~@/assets/images/ic_checkbox.png") !important;
}

.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {
  background-color: #bdcbd6 !important;
  border-color: #bdcbd6 !important;
}

.custom-checkbox .custom-control-input:disabled~.custom-control-label::before {
  background-color: #bdcbd6 !important;
  border-color: #bdcbd6 !important;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
  border: var(--color-primary) solid 1px !important;
}

.custom-control-input:checked~.custom-control-label::before {
  border-color: var(--color-primary) !important;
  background-color: var(--color-primary) !important;
}
</style>
